import { useRef, useCallback } from 'react';

export function useMultiClick(targetClicks: number, onTrigger: () => void, timeWindow = 2000) {
  const clickCount = useRef(0);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleClick = useCallback(() => {
    clickCount.current += 1;

    if (timer.current) {
      clearTimeout(timer.current);
    }

    if (clickCount.current >= targetClicks) {
      clickCount.current = 0;
      onTrigger();
      return;
    }

    timer.current = setTimeout(() => {
      clickCount.current = 0;
    }, timeWindow);
  }, [targetClicks, onTrigger, timeWindow]);

  return handleClick;
}
